function install(app) {
    app.config.globalProperties.$filters = {
        currencyCHF(value) {
            if (typeof value !== "number") {
                return value;
            }
            var formatter = new Intl.NumberFormat('de-CH', {
                style: 'currency',
                currency: 'CHF'
            });
            return formatter.format(value);

        },
    };
}

var index = {
    install,
};

export { index as default };
